import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const BranchWorkspaceSelector = styled.div`
  display: flex;
  gap: 10px;
`;

export const CommitInfo = styled.div`
  display: flex;
  gap: 5px;
  font-size: 0.8rem;
  color: ${colors.secondary.mediumGray};
  align-items: center;
`;

export const List = styled.div`
  max-height: 350px;
  overflow-y: auto;
  background: ${colors.primary.white};
  /* border-top: 1px solid ${colors.secondary.lightGray3}; */
  & > button {
    border-bottom: 1px solid ${colors.secondary.lightGray3};
    &:first-child {
      border-top: none;
    }
    &:last-child {
      border-bottom: none;
    }
  }
`;

export const ListItem = styled.button`
  border: none;
  /* padding: 0; */
  width: 100%;
  /* display: block; */

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: none;

  display: flex;
  gap: 0px;
  padding: 10px 20px 10px 5px;

  .list-item-content {
    /* gap: 2px !important; */
  }

  .commit-message {
    font-size: 0.8rem;
    margin: 5px -10px 0;
    padding: 5px 12px 0;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:hover {
    background-color: ${colors.semantic.information.light};
  }
`;
